import { createIcon } from './factory'
import Icon from './house.svg?react'

export const House = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
